import React from 'react';

const Button = ({ children, flat, startIcon, endIcon, className, active, size, ...props }) => {

	const generateClassNames = () => {
		const classNames = [];

		classNames.push('btn')

		if(flat) {
			classNames.push('btn-secondary')
		} else {
			classNames.push('btn-primary');
		}

		if(props.disabled) {
			classNames.push('btn-disabled')
		}

		if(size === 'md') {
			classNames.push('btn-medium');
		} else if (size === 'lg') {
			classNames.push('btn-large');
		} else if (size === 'full') {
			classNames.push('btn-full');
		} else if(startIcon || endIcon) {
			classNames.push('btn-with-icon');
		} else {
			classNames.push('btn-regular')
		}
		
		if(className) {
			classNames.push(className);
		}

		return classNames.join(' ');
	};

	return (
		<button className={`${generateClassNames()}`} {...props}>
			{startIcon && (
				<div className='btn-icon-wrapper'>
					<span>{startIcon}</span>
					<span className='min-w-[56px]'>{children}</span>
				</div>
			)}

			{endIcon && (
				<div className='btn-icon-wrapper'>
					<span className='min-w-[56px]'>{children}</span>
					<span>{endIcon}</span>
				</div>
			)}		
			{(!startIcon && !endIcon) && children}
		</button>
	);
}

export default Button;